var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject } from "aurelia-framework";
import { BaseTemplate } from "../../../styles/client/templates/base-template";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { ClientLotteryClientService } from "../../../services/modules/client/client-lottery-client-service";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { BundleKeyHelper } from "../../../services/modules/brand-client.service";
var ClientWidget = /** @class */ (function (_super) {
    __extends(ClientWidget, _super);
    function ClientWidget(router, lotteryClientService, i18N, dialogClientService, tokenClient) {
        return _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
    }
    ClientWidget.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        var promiseBundles = new Promise(function (resolve, reject) {
            _this.clientLotteryClientService.getLobbyBundles({}).then(function (x) {
                _this.bundles = x;
                resolve();
            }, function (x) {
                reject();
            });
        });
        return new Promise(function (resolve, reject) { Promise.all([promise, promiseBundles]).then(function (x) { resolve(); }, reject); });
        ;
    };
    ClientWidget.prototype.attached = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lotteryName, bundleName, key, anyConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.attached.call(this);
                        try {
                            require("../../../styles/client/widgets/" + this.tokenClient.user.templateName + "/widget");
                        }
                        catch (_b) { }
                        lotteryName = this.getUrlParameter("lotteryName");
                        bundleName = this.getUrlParameter("bundleName");
                        this.isLottery = lotteryName != null && lotteryName != "";
                        this.isBundle = bundleName != null && bundleName != "";
                        if (!(lotteryName || bundleName)) return [3 /*break*/, 2];
                        key = this.isBundle ? this.getBundleKey(bundleName) : this.isLottery ? this.getLotteryKey(lotteryName) : "";
                        return [4 /*yield*/, this.clientLotteryClientService.anyConfigForLotteryKey(key)];
                    case 1:
                        anyConfig = _a.sent();
                        if (this.isBundle) {
                            this.currentBundle = anyConfig ? this.getBundleByKey(this.bundles, key) : {
                                name: "default"
                            };
                        }
                        else if (this.isLottery) {
                            this.currentLottery = anyConfig ? this.getLotteryByKey(this.lotteries, key) : {
                                lotteryName: "default",
                                drawDate: new Date(),
                                closingDateTime: new Date(),
                                ticketSalesClosingTime: new Date(),
                                sunday: true,
                                monday: true,
                                tuesday: true,
                                wednesday: true,
                                thursday: true,
                                friday: true,
                                saturday: true,
                            };
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ClientWidget.prototype.getBundleByKey = function (bundles, key) {
        return BundleKeyHelper.getBundleByKey(bundles, key);
    };
    ClientWidget.prototype.getUrlParameter = function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    ClientWidget.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    ClientWidget.prototype.shouldSendHeightToClient = function () {
        return true;
    };
    ClientWidget.prototype.getRouterView = function () {
        return ".page-client-widget";
    };
    ClientWidget = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, I18N, DialogClientService, TokenClient])
    ], ClientWidget);
    return ClientWidget;
}(BaseTemplate));
export { ClientWidget };
